import React from 'react';

const ContactInformation = () => {
    return (
        <div className='mainPage'>
            <h2 className='textTitle text-uppercase fw-medium'>Contact information</h2>
            <p>Even though Israel is a small country it is always in the news. The news continues to report on Jews
                moving to Israel, on the technology invented there, but also on conflict, wars and tensions with
                surrounding people. Why? A look at Israel’s history in the book of Genesis in the Bible reveals that
                4000 years ago a man, who is now very well known, went on a camping trip in that part of the world. The
                Bible says that his story affects our future. This ancient man is Abraham (also known as Abram). We can
                take his story seriously because the places and cities he visited are mentioned in other old
                writings.</p>
        </div>
    );
};

export default ContactInformation;
